/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Layout from "../../components/Layout/Layout";

const NewServices = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: "ease-out",
            once: false,
        });
    }, []);
    return (
        <>
            <Layout>
                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Personalized Programs
                                    </h1>
                                    <div className="text_24_service">
                                        Customized wellness programs tailored to each user's specific needs, including recommendations for exercise, nutrition, stress management, and more.
                                    </div>
                                    <div className="text_18_service">
                                        All programs will be available in the first quarter of 2025. These offerings are currently under development and will be ready for integration soon. Join the waiting list to access these innovative services.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service1.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="program-categories container">
                    <h3 class="section-title">Our Wellness Programs</h3>

                    <div class="row">
                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Healthcare</h4>
                                <p className="text_24_service">Track and manage your health with interactive analyses.</p>
                                <div class="effect">
                                    <img src="/img/service1.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/healthcare-solutions" class="btn btn-primary explore-btn">Click to explore personalized healthcare solutions</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Fitness and Wellness</h4>
                                <p className="text_24_service">Fitness programs tailored to your goals, with real-time tracking.</p>
                                <div class="effect">
                                    <img src="/img/service2.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/fitness-programs" class="btn btn-primary explore-btn">Click to discover personalized fitness programs</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Corporate Wellness</h4>
                                <p className="text_24_service">Wellness workshops designed to enhance workplace health and productivity.</p>
                                <div class="effect">
                                    <img src="/img/service3.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/corporate-wellness" class="btn btn-primary explore-btn">Click to learn more about our corporate wellness programs</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Mental Health</h4>
                                <p className="text_24_service">Stress management and mental health programs for a serene mind.</p>
                                <div class="effect">
                                    <img src="/img/service4.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/mental-health-solutions" class="btn btn-primary explore-btn">Click to access our mental health solutions</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Sports and Athletics</h4>
                                <p className="text_24_service">Optimize athletic performance with real-time data insights.</p>
                                <div class="effect">
                                    <img src="/img/service5.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/athlete-programs" class="btn btn-primary explore-btn">Click to explore our programs for athletes</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Nutrition</h4>
                                <p className="text_24_service">Nutrition plans and food tracking for balanced eating.</p>
                                <div class="effect">
                                    <img src="/img/service6.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/nutrition-programs" class="btn btn-primary explore-btn">Click to discover our nutrition programs</a>
                            </div>
                        </div>

                        <div class="col-md-6 mb-4">
                            <div class="category-card">
                                <h4>Education</h4>
                                <p className="text_24_service">Wellness resources for NGOs and communities.</p>
                                <div class="effect">
                                    <img src="/img/service7.jpeg" className="w-100 h-100 object-fit-cover" alt="" data-aos="zoom-out-up" />
                                </div>
                                <a href="/educational-resources" class="btn btn-primary explore-btn">Click to access our educational wellness resources</a>
                            </div>
                        </div>
                    </div>
                </div>





                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Real-Time Health Monitoring
                                    </h1>
                                    <div className="text_24_service">
                                        Utilize wearable devices to monitor various health parameters in real-time, providing instant and personalized recommendations.
                                    </div>
                                    <div className="text_18_service">
                                        Our real-time health monitoring service connects seamlessly with your wearable devices to track key health metrics like heart rate, sleep quality, activity levels, and more. Receive instant feedback and tailored insights to help you stay proactive about your health.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service2.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="key-features-section container">
                    <h3 class="section-title">Key Features</h3>

                    <div class="feature-list">
                        <div class="feature-item">
                            <h4>Real-Time Heart Rate Monitoring</h4>
                            <p className="text_24_service">Get instant updates on your heart rate and receive alerts when abnormalities are detected.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Sleep Quality Analysis</h4>
                            <p className="text_24_service">Monitor your sleep patterns to understand and improve your sleep quality.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Activity and Fitness Tracking</h4>
                            <p className="text_24_service">Track your steps, workouts, and overall activity levels with precision.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Personalized Health Insights</h4>
                            <p className="text_24_service">Receive customized health recommendations based on your real-time data.</p>
                        </div>
                    </div>
                </div>



                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Immersive Retreats
                                    </h1>
                                    <div className="text_24_service">
                                        Comprehensive wellness experiences in serene natural environments, combining yoga, meditation, nutrition, and personal development.
                                    </div>
                                    <div className="text_18_service">
                                        Our immersive retreats are designed to offer a holistic approach to well-being by integrating physical, mental, and emotional health practices. Join us in tranquil settings for an experience that nurtures your body, mind, and soul. The first center will launch in the Landes, France, by 2028, providing a unique retreat experience.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service3.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="retreat-features-section container">
                    <h3 class="section-title">Retreat Features</h3>

                    <div class="feature-list">
                        <div class="feature-item">
                            <h4>Yoga and Meditation Sessions</h4>
                            <p className="text_24_service">Daily sessions designed to balance your mind, body, and spirit.</p>
                        </div>
                        <div class="feature-item">
                            <h4>Personal Development Workshops</h4>
                            <p className="text_24_service">Interactive workshops on self-awareness, mindfulness, and growth.</p>
                        </div>
                        <div class="feature-item">
                            <h4>Nutritional Guidance</h4>
                            <p className="text_24_service">Healthy meal plans crafted by expert nutritionists.</p>
                        </div>
                        <div class="feature-item">
                            <h4>Serene Natural Settings</h4>
                            <p className="text_24_service">Retreats hosted in beautiful, calming environments.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Secure Health Data Management
                                    </h1>
                                    <div className="text_24_service">
                                        A platform to centralize and protect all health documents with easy access and robust security measures.
                                    </div>
                                    <div className="text_18_service">
                                        Our secure health data management service ensures that all your medical records and health-related documents are safely stored in one place, easily accessible whenever needed, and fully protected by the latest security technologies.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service4.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="key-features-section container">
                    <h3 class="section-title">Key Features</h3>

                    <div class="feature-list">
                        <div class="feature-item">
                            <h4>Centralized Health Document Storage</h4>
                            <p className="text_24_service">Keep all your health documents in one secure location for easy access and management.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Advanced Encryption and Security</h4>
                            <p className="text_24_service">State-of-the-art encryption ensures that your personal health data remains confidential and secure.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Easy Access Anytime</h4>
                            <p className="text_24_service">Access your health records at any time, from anywhere, using any device.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        AI-Powered Virtual Counselor
                                    </h1>
                                    <div className="text_24_service">
                                        An intelligent virtual counselor that offers personalized wellness recommendations and 24/7 support.
                                    </div>
                                    <div className="text_18_service">
                                        Meet your new wellness partner: our AI-Powered Virtual Counselor. Designed to provide personalized guidance, instant feedback, and round-the-clock support, it understands your needs and helps you achieve your health goals with ease.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service5.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="key-features-section container">
                    <h3 class="section-title">Key Features</h3>

                    <div class="feature-list">
                        <div class="feature-item">
                            <h4>Personalized Wellness Recommendations</h4>
                            <p className="text_24_service">Receive tailored advice based on your unique health profile, preferences, and lifestyle.</p>
                        </div>

                        <div class="feature-item">
                            <h4>24/7 Availability</h4>
                            <p className="text_24_service">Get support whenever you need it, day or night, through a friendly and responsive interface.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Continuous Learning and Adaptation</h4>
                            <p className="text_24_service">The virtual counselor learns from your interactions to provide increasingly accurate and relevant suggestions.</p>
                        </div>
                    </div>
                </div>



                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Content and Services Library
                                    </h1>
                                    <div className="text_24_service">
                                        Access to a vast collection of wellness resources, including videos, articles, podcasts, and webinars created by leading experts.
                                    </div>
                                    <div className="text_18_service">
                                        Explore a wealth of wellness resources in our Content and Services Library. From engaging videos and insightful articles to interactive podcasts and webinars, all crafted by top experts in the field, this library is your ultimate tool for personal growth and well-being.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service6.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>

                <div class="container">
                    <p class="text_24_service">
                        This service will be available starting from the first quarter of 2025. Reserve your spot now and be among the first to access our comprehensive wellness library.
                    </p>
                </div>

                <div class="key-features-section container">
                    <h3 class="section-title">Key Features</h3>

                    <div class="feature-list">
                        <div class="feature-item">
                            <h4>Expert-Curated Content</h4>
                            <p className="text_24_service">Benefit from resources developed by renowned wellness professionals, covering various health and well-being topics.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Multimedia Resources</h4>
                            <p className="text_24_service">Access a diverse range of formats including videos, articles, podcasts, and webinars to suit your learning style.</p>
                        </div>

                        <div class="feature-item">
                            <h4>Regular Updates</h4>
                            <p className="text_24_service">Stay informed with regularly updated content that reflects the latest in wellness trends and research.</p>
                        </div>
                    </div>
                </div>


                <section className="section section-masthead">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="text-black" data-aos="zoom-in-left">
                                <div className="overflow ps-5">
                                    <h1 className="text_48_service" data-aos="zoom-out-up">
                                        Advanced Bloodwork Analysis
                                    </h1>
                                    <div className="text_24_service">
                                        Revolutionizing health management with AI-powered bloodwork analysis, available in the first quarter of 2025.
                                    </div>
                                    <div className="text_18_service">
                                        Our advanced bloodwork analysis service leverages AI technology to provide detailed insights into your health. By securely uploading your blood reports, receive personalized recommendations based on your genetic and blood data to stay ahead of potential health issues.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <img src="/img/service7.jpeg" className="w-100" alt="" data-aos="zoom-out-up" />
                        </div>
                    </div>
                </section>


                <div class="container">
                    <p class="text_24_service">
                        This service will be available in the first quarter of 2025. Join our waitlist to be among the first to experience advanced health management with AI-powered bloodwork analysis.
                    </p>
                </div>

                <div class="key-features-section container">
                    <h3 class="section-title">Key Features</h3>

                    <div class="feature-list">

                        <div class="feature-item">
                            <h4>Secure Upload of Blood Reports</h4>
                            <p className="text_24_service">Easily upload your blood reports via our secure platform.</p>
                        </div>


                        <div class="feature-item">
                            <h4>Detailed Health Analysis</h4>
                            <p className="text_24_service">Receive comprehensive analyses highlighting key health insights and personalized recommendations.</p>
                        </div>


                        <div class="feature-item">
                            <h4>Continuous Monitoring with Alerts</h4>
                            <p className="text_24_service">Get real-time alerts for any detected abnormalities, enabling proactive preventive measures.</p>
                        </div>
                    </div>
                </div>


            </Layout>
        </>
    );
};

export default NewServices;
